module.exports = __webpack_public_path__ + "static/media/logo-wordmark-white.1a3ea488.png";